import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';
import LocomotiveScroll from 'locomotive-scroll';
import $transitions from '@/_modules/Transitions';
import gnav from '@/_modules/common/gnav';
import historyApi from '@/_modules/common/historyApi';
import footer from '@/_modules/common/footer';
import topGl from '@/_modules/top/topGl';
$transitions.loadStart();

// page
import top from '@/_page/top';

export default class Main {
  constructor() {
    this.getHeight100();
    this.isInit = false;
    this.isGLReady = false;
    this.winH = 0;
    this.conH = 0;
  }

  // webgl準備完了で実行する
  onGlReady() {
    if (this.isGLReady) return;
    this.isGLReady = true;
    requestAnimationFrame(this.start.bind(this));
  }

  // html準備完了で実行する
  onInit() {
    if (this.isInit) return;
    this.isInit = true;
    historyApi.init();
    requestAnimationFrame(this.start.bind(this));
  }

  start() {
    if (this.isGLReady && this.isInit) {
      $transitions.hideOnce(function(){
        // webglスタート実行
        topGl.startOpening();
      });

      setTimeout(this.start2.bind(this), 1400);
    }
  }

  start2() {
    gnav.start();
    top.mvStart();
  }

  init() {
    window.$scroll = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: gAMBR.isSmoothScroll,
      lerp: 0.3,
      //multiplier: 0.8,
      getDirection: true,
      tablet: {
        smooth: false
      },
      smartphone: {
        smooth: false
      },
      resetNativeScroll: false,
    });

    /*
    this.bindScroll = this.scroll.bind(this);
    if (gAMBR.isSmoothScroll) {
      window.$scroll.on('scroll', this.bindScroll);
    } else {
      window.addEventListener('scroll', this.bindScroll);
    }
    */

    window.$scroll.on('call', (e, direction, el) => {
      switch (e) {
        case 'footer':
          if (direction === 'enter') {
            // enter
            //console.log('footer enter');
          } else {
            // exit
            //console.log('footer exit');
          }
          break;
        case 'lead':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__lead');
          }
          break;
        case 'what':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__what');
          }
          break;
        case 'product':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__product');
          }
          break;
        case 'casestudy':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__casestudy');
          }
          break;
        // case 'about':
        //   if (direction === 'enter') {
        //     // enter
        //     top.inview('p-top__about');
        //   }
        //   break;
        // case 'ourvalue':
        //   if (direction === 'enter') {
        //     // enter
        //     top.inview('p-top__value');
        //   }
        //   break;
        case 'company':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__company');
          }
          break;
        case 'career':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__career');
          }
          break;
        case 'news':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__news');
          }
          break;
        case 'contact':
          if (direction === 'enter') {
            // enter
            top.inview('p-top__contact');
          }
          break;
      }
    });

    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.getElementById('c-container'));

    gnav.once({isTop:true});
    footer.once();

    gEvent.on('OPEN_GNAV', this.openNav.bind(this));
    gEvent.on('CLOSE_GNAV', this.closeNav.bind(this));

    this.initPage();

    requestAnimationFrame(this.onInit.bind(this));
  }

  openNav() {
    //window.$scroll.stop();
  }

  closeNav() {
    //window.$scroll.start();
  }

  initPage() {
    const namespace = 'top';

    // rootにclass追加
    gAMBR.rootHTML.classList.add(`is-page-top`);

    top.init();
    gnav.init(namespace);
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize(entries) {
    //this.getHeight100();
    this.winH = window.innerHeight;
    this.conH = document.getElementById('c-container').getBoundingClientRect().height;
    window.$scroll.update();
  }

  scroll(e) {
    let scrollY = 0;
    if (gAMBR.isSmoothScroll) {
      scrollY = e.scroll.y;
    } else {
      scrollY = utils.getScrollTop();
    }
  }
}
